<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  selectedTicket: { type: Object, required: true },
  assigneeOptions: { type: Array, default: () => [] },
  priorityOptions: { type: Array, default: () => [] },
  isUpdatingAssignee: { type: Boolean, default: false },
  isUpdatingPriority: { type: Boolean, default: false },
});

const emit = defineEmits(['updateAssignee', 'updatePriority']);

const { t } = useI18n();
</script>

<template>
  <section
    class="grid gap-3 rounded-lais border border-lais-border-soft bg-white px-4 py-3"
  >
    <h3 class="text-[13px] font-semibold text-lais-text">
      {{ t('SUPPORT_TICKETS.TRIAGE.TITLE') }}
    </h3>
    <div class="grid gap-3 sm:grid-cols-2">
      <LaisField :label="t('SUPPORT_TICKETS.TRIAGE.ASSIGNEE')">
        <select
          :value="selectedTicket.assignee?.id || ''"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
          :disabled="isUpdatingAssignee"
          @change="emit('updateAssignee', $event.target.value)"
        >
          <option
            v-for="item in assigneeOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </LaisField>
      <LaisField :label="t('SUPPORT_TICKETS.TRIAGE.PRIORITY')">
        <select
          :value="selectedTicket.sla?.priority || selectedTicket.priority"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
          :disabled="isUpdatingPriority"
          @change="emit('updatePriority', $event.target.value)"
        >
          <option
            v-for="item in priorityOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </LaisField>
    </div>
  </section>
</template>
